export default __webpack_public_path__ + "static/media/instructions_1.106e0b91.svg";